// This file is generated by @expo-google-fonts/generator
// If you want to modify it, go to packages/generator/templates

export const IBMPlexSans_400Regular = require('./IBMPlexSans_400Regular.ttf');
